import React from 'react';

import { MapPinIcon } from '@heroicons/react/24/solid';
import { useIntl } from 'react-intl';

import ModalLayout from './ModalLayout';

import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { Button } from '@/components/buttons/Button';
import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';

function OntarioCheckModal({ closeModal }: { closeModal: () => void }): JSX.Element {
  const intl = useIntl();
  const locale = useSelector(selectLocale);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const navigate = useAbsoluteNavigate();

  const onClickHandler = () => {
    triggerGTag(GTagEvents.ontario_check_cta);
    window.location.href = locale === 'ca-fr' ? 'https://luckydays.ca/fr' : 'https://luckydays.ca';
  };

  const onLogoutClick = () => {
    navigate('/logout');
    closeModal();
  };

  return (
    <ModalLayout data-testid="ontario-check-modal">
      <div className="w-full text-center grid grid-cols-1 gap-8">
        <div className="flex justify-center">
          <MapPinIcon className="w-10 h-10" />
        </div>
        <div className="text-lg font-bold">
          {intl.formatMessage({ id: 'ontario.check.header' })}
        </div>
        <div>{intl.formatMessage({ id: 'ontario.check.text' })}</div>
        <Button
          onClickHandler={onClickHandler}
          btnType="primary"
          text={intl.formatMessage({ id: 'ontario.check.cta' })}
        />
        {isAuthenticated && (
          <Button
            onClickHandler={onLogoutClick}
            btnType="outline"
            text={intl.formatMessage({ id: 'header.logout' })}
          />
        )}
      </div>
    </ModalLayout>
  );
}

export default OntarioCheckModal;
